export type ImageVariant = 'public' | 'thumbnail' | 'card';

/**
 * Build a Cloudflare Images delivery URL from a stored imageId.
 * Pure URL builder — safe to use in browser code. The `accountHash` is the
 * publicly visible hash (not the API token).
 */
export function cfImageUrl(
  imageId: string,
  accountHash: string | undefined,
  variant: ImageVariant = 'public',
): string {
  if (!accountHash || accountHash === 'placeholder') return imageId;
  return `https://imagedelivery.net/${accountHash}/${imageId}/${variant}`;
}
